import type {
	Maybe,
	Product_Group_Types_Enum,
} from "@app/modules/graphql-api-types.generated";
import type { TranslateFunction } from "@app/modules/i18n/types";

export const PRODUCT_GROUP_CONTAINER = "CONTAINER";
export const PRODUCT_GROUP_CONTAINER_PALLET = "CONTAINER_PALLET";
export const PRODUCT_GROUPS_EDI_CONTAINERS = [
	"CONTAINER_EDI_KARTON",
	"CONTAINER_EDI_PALLET",
	"CONTAINER_EDI_PALOXE",
];

export function isContainerProduct(product: {
	productGroupMembers: Array<{ productGroup: { name: string } }>;
}) {
	return product.productGroupMembers.some(
		({ productGroup: { name } }) => name === PRODUCT_GROUP_CONTAINER,
	);
}

export function isContainerPalletProduct(product: {
	productGroupMembers: Array<{ productGroup: { name: string } }>;
}) {
	return product.productGroupMembers.some(
		({ productGroup: { name } }) => name === PRODUCT_GROUP_CONTAINER_PALLET,
	);
}

export function isEDIContainerProduct(product: {
	productGroupMembers: Array<{ productGroup: { name: string } }>;
}) {
	return product.productGroupMembers.some(({ productGroup: { name } }) =>
		PRODUCT_GROUPS_EDI_CONTAINERS.includes(name),
	);
}

export function getProductGroupName({
	internalName,
	name,
}: {
	internalName?: Maybe<string> | undefined;
	name: string;
}) {
	return internalName ?? name;
}

export function getProductGroupTypeName(
	t: TranslateFunction,
	type: Product_Group_Types_Enum,
) {
	return t(`product-groups.types.${type}`);
}
